<template>
  <div :style="rootStyle">
    <Navbar v-if="!hideNavbar" />
    <InternalUserInfoBar v-if="!hideNavbar" />
    <router-view v-slot="{ Component }">
      <keep-alive :include="['MyPatients']">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
import Navbar from './Navbar.vue';
import InternalUserInfoBar from './InternalUserInfoBar.vue';
import { isEmbedMode } from '@/utils/embedMode';
import { isInternalUser } from '@/utils/internalUser';

// Fixed chrome heights above the router-view: the navbar, plus the internal-user bar
// when it renders. Kept in sync with .navbar__inner / .internal-user-info-bar.
const NAV_HEIGHT = 60;
const INTERNAL_USER_BAR_HEIGHT = 28;

export default {
  components: {
    Navbar,
    InternalUserInfoBar,
  },
  computed: {
    // Hide the navbar only when the app is embedded in va-portal as an iframe
    // (signaled by ?embed=true on /my-practice/practice-setting).
    hideNavbar() {
      return isEmbedMode(this.$route);
    },
    // Mirrors InternalUserInfoBar's own v-if, so the height reserved below matches what
    // actually renders.
    showInternalUserInfoBar() {
      return !this.hideNavbar && isInternalUser(this.$store.state.login.userInfo);
    },
    // --nav-height (60px, set in main.css) is how much fixed chrome the sidebar and
    // content panes reserve at the top. Override it on this subtree so it always matches
    // reality: 0 when the navbar is hidden (embed mode), and navbar + bar when the
    // internal-user bar is present — otherwise those panes would be too tall by the
    // bar's height and overflow the viewport.
    rootStyle() {
      if (this.hideNavbar) {
        return { '--nav-height': '0px' };
      }
      if (this.showInternalUserInfoBar) {
        return { '--nav-height': `${NAV_HEIGHT + INTERNAL_USER_BAR_HEIGHT}px` };
      }
      return null;
    },
  },
};
</script>

<style scoped></style>
